export async function waitUntil(
  conditionFn: () => Promise<boolean>,
  interval: number = 1000,
  setTimeoutId: ((id: NodeJS.Timeout) => void) | null = null,
  maxTime: number | null = null,
  exitOnError: boolean = false
): Promise<void> {
  const start = Date.now();
  return new Promise((resolve, reject) => {
    const checkCondition = () => {
      if (maxTime && Date.now() - start > maxTime) {
        console.log("Condition not met within max time");
        reject(new Error("Condition not met within max time"));
        return;
      }

      conditionFn()
        .then((result) => {
          if (result) {
            resolve();
            return;
          }

          setTimeoutId && setTimeoutId(setTimeout(checkCondition, interval));
        })
        .catch((error) => {
          if (exitOnError) {
            reject(error);
            return;
          }

          setTimeoutId && setTimeoutId(setTimeout(checkCondition, interval));
        });
    };

    setTimeoutId && setTimeoutId(setTimeout(checkCondition, interval));
  });
}
